/**
 * ============================================
 * FordSync4 Guides - Comment Widget
 * 
 * 嵌入方式: 在 Shopify blog article 模板底部加一行:
 * <div id="fs4-comments" data-handle="{{ article.handle }}"></div>
 * <script src="https://fordsync4-comments.<your-subdomain>.workers.dev/widget.js"></script>
 * 
 * 或者把这个文件上传到 Shopify 的 Assets，用:
 * <script src="{{ 'fs4-comments.js' | asset_url }}"></script>
 * ============================================
 */

(function() {
  'use strict';

  // ---- 配置 ----
  const API_BASE = 'https://fordsync4-comments.fordsync4.workers.dev';
  // 部署后替换为你的 Cloudflare Worker URL

  const container = document.getElementById('fs4-comments');
  if (!container) return;

  const articleHandle = container.dataset.handle;
  if (!articleHandle) return;

  // ---- State ----
  let currentUser = null;
  let comments = [];
  let replyTo = null;

  function getToken() { return localStorage.getItem('fs4_token'); }
  function setToken(t) { localStorage.setItem('fs4_token', t); }
  function clearToken() { localStorage.removeItem('fs4_token'); }

  // ---- API ----
  async function api(path, options = {}) {
    const token = getToken();
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    
    const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
    return res.json();
  }

  // ---- Render ----
  function render() {
    container.innerHTML = '';
    container.appendChild(createStyles());
    container.appendChild(createHeader());
    
    if (!currentUser) {
      container.appendChild(createLoginForm());
    } else {
      container.appendChild(createUserBar());
      container.appendChild(createCommentForm(null));
    }

    container.appendChild(createCommentList());
  }

  function createStyles() {
    const style = document.createElement('style');
    style.textContent = `
      #fs4-comments { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 100%; margin: 40px 0; color: #1a202c; }
      .fs4-header { border-top: 3px solid #003478; padding: 20px 0 12px; margin-bottom: 16px; }
      .fs4-header h3 { font-size: 20px; font-weight: 700; color: #003478; margin: 0 0 4px; }
      .fs4-header p { font-size: 14px; color: #718096; margin: 0; }
      .fs4-login { background: #f7fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 20px; margin-bottom: 20px; }
      .fs4-login h4 { font-size: 16px; font-weight: 600; margin: 0 0 12px; }
      .fs4-login .fields { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
      .fs4-login input { width: 100%; padding: 10px 12px; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 14px; box-sizing: border-box; }
      .fs4-login input:focus { border-color: #00a3e0; outline: none; box-shadow: 0 0 0 3px rgba(0,163,224,0.12); }
      .fs4-login .hint { font-size: 12px; color: #a0aec0; margin-top: 4px; }
      .fs4-btn { display: inline-flex; align-items: center; padding: 8px 18px; border: none; border-radius: 6px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.15s; }
      .fs4-btn-primary { background: #003478; color: #fff; }
      .fs4-btn-primary:hover { background: #1a5dab; }
      .fs4-btn-sm { padding: 4px 10px; font-size: 12px; }
      .fs4-btn-ghost { background: none; border: 1px solid #e2e8f0; color: #718096; }
      .fs4-btn-ghost:hover { border-color: #003478; color: #003478; }
      .fs4-user-bar { display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; background: #f0f7ff; border-radius: 8px; margin-bottom: 16px; font-size: 14px; }
      .fs4-user-badge { font-weight: 600; color: #003478; }
      .fs4-admin-badge { background: #003478; color: #fff; font-size: 11px; padding: 2px 8px; border-radius: 4px; margin-left: 6px; }
      .fs4-comment-form { margin-bottom: 20px; }
      .fs4-comment-form textarea { width: 100%; padding: 12px; border: 1px solid #e2e8f0; border-radius: 8px; font-size: 14px; font-family: inherit; resize: vertical; min-height: 80px; box-sizing: border-box; }
      .fs4-comment-form textarea:focus { border-color: #00a3e0; outline: none; }
      .fs4-form-footer { display: flex; justify-content: space-between; align-items: center; margin-top: 8px; }
      .fs4-replying { font-size: 13px; color: #00a3e0; margin-bottom: 8px; display: flex; gap: 8px; align-items: center; }
      .fs4-comment { padding: 16px; border: 1px solid #e2e8f0; border-radius: 8px; margin-bottom: 10px; transition: border-color 0.15s; }
      .fs4-comment:hover { border-color: #cbd5e0; }
      .fs4-comment-reply { margin-left: 28px; border-left: 3px solid #00a3e0; border-radius: 0 8px 8px 0; }
      .fs4-comment-head { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin-bottom: 8px; }
      .fs4-comment-author { font-weight: 600; font-size: 14px; }
      .fs4-verified { color: #00a3e0; font-size: 12px; }
      .fs4-vehicle { font-size: 11px; background: #edf2f7; padding: 2px 8px; border-radius: 4px; color: #718096; }
      .fs4-comment-time { font-size: 12px; color: #a0aec0; }
      .fs4-comment-body { font-size: 15px; line-height: 1.65; color: #2d3748; white-space: pre-wrap; word-break: break-word; }
      .fs4-comment-actions { display: flex; gap: 14px; margin-top: 10px; font-size: 13px; }
      .fs4-comment-actions button { background: none; border: none; cursor: pointer; color: #718096; font-size: 13px; padding: 0; }
      .fs4-comment-actions button:hover { color: #003478; }
      .fs4-solution { border-color: #38a169; background: #f0fff4; }
      .fs4-solution-badge { display: inline-block; background: #38a169; color: #fff; font-size: 11px; font-weight: 700; padding: 2px 8px; border-radius: 4px; margin-bottom: 8px; }
      .fs4-empty { text-align: center; padding: 32px; color: #a0aec0; font-size: 15px; }
      .fs4-error { background: #fff5f5; color: #c53030; padding: 10px 14px; border-radius: 6px; font-size: 14px; margin-bottom: 12px; border: 1px solid #fed7d7; }
      .fs4-loading { text-align: center; padding: 24px; color: #a0aec0; }
      @media (max-width: 600px) { .fs4-login .fields { grid-template-columns: 1fr; } }
    `;
    return style;
  }

  function createHeader() {
    const div = document.createElement('div');
    div.className = 'fs4-header';
    div.innerHTML = `
      <h3>Solutions & Discussion</h3>
      <p>${comments.length} comment${comments.length !== 1 ? 's' : ''} from verified customers</p>
    `;
    return div;
  }

  function createLoginForm() {
    const div = document.createElement('div');
    div.className = 'fs4-login';
    div.innerHTML = `
      <h4>Have a question or tip to share?</h4>
      <p style="font-size:14px;color:#718096;margin:0 0 14px">Sign in with your order to comment, share solutions, and help fellow owners.</p>
      <div class="fields">
        <div>
          <input type="text" id="fs4-order" placeholder="Order # (e.g., FS41234)" />
          <div class="hint">From your confirmation email</div>
        </div>
        <div>
          <input type="text" id="fs4-name" placeholder="Name on order" />
          <div class="hint">First, last, or full name</div>
        </div>
      </div>
      <div id="fs4-login-error"></div>
      <div style="margin-top:14px">
        <button class="fs4-btn fs4-btn-primary" id="fs4-login-btn">Verify & Sign In</button>
      </div>
    `;

    setTimeout(() => {
      const btn = document.getElementById('fs4-login-btn');
      btn?.addEventListener('click', handleLogin);
      // Enter key
      ['fs4-order', 'fs4-name'].forEach(id => {
        document.getElementById(id)?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') handleLogin();
        });
      });
    }, 0);

    return div;
  }

  function createUserBar() {
    const div = document.createElement('div');
    div.className = 'fs4-user-bar';
    const badge = currentUser.role === 'admin'
      ? `${currentUser.displayName}<span class="fs4-admin-badge">Admin</span>`
      : `🚗 ${currentUser.displayName}`;
    div.innerHTML = `
      <span class="fs4-user-badge">${badge}</span>
      <button class="fs4-btn fs4-btn-sm fs4-btn-ghost" id="fs4-logout-btn">Sign Out</button>
    `;
    setTimeout(() => {
      document.getElementById('fs4-logout-btn')?.addEventListener('click', () => {
        clearToken();
        currentUser = null;
        render();
      });
    }, 0);
    return div;
  }

  function createCommentForm(parentId) {
    const div = document.createElement('div');
    div.className = 'fs4-comment-form';
    const formId = parentId ? `fs4-reply-${parentId}` : 'fs4-main-form';
    div.innerHTML = `
      ${parentId ? '<div class="fs4-replying">Replying to comment <button id="fs4-cancel-reply">✕ Cancel</button></div>' : ''}
      <textarea id="${formId}-textarea" placeholder="${parentId ? 'Write your reply...' : 'Share your experience, ask a question, or help others...'}" rows="${parentId ? 3 : 4}"></textarea>
      <div class="fs4-form-footer">
        <span style="font-size:12px;color:#a0aec0">Tip: describe your vehicle model to help others</span>
        <button class="fs4-btn fs4-btn-primary fs4-btn-sm" id="${formId}-submit">Post</button>
      </div>
    `;

    setTimeout(() => {
      document.getElementById(`${formId}-submit`)?.addEventListener('click', async () => {
        const textarea = document.getElementById(`${formId}-textarea`);
        const content = textarea?.value?.trim();
        if (!content) return;

        const btn = document.getElementById(`${formId}-submit`);
        btn.textContent = 'Posting...';
        btn.disabled = true;

        const result = await api('/api/comments', {
          method: 'POST',
          body: JSON.stringify({ articleHandle, content, parentId }),
        });

        if (result.success) {
          await loadComments();
          render();
        } else {
          alert(result.error || 'Failed to post.');
          btn.textContent = 'Post';
          btn.disabled = false;
        }
      });

      if (parentId) {
        document.getElementById('fs4-cancel-reply')?.addEventListener('click', () => {
          replyTo = null;
          render();
        });
      }
    }, 0);

    return div;
  }

  function createCommentList() {
    const div = document.createElement('div');

    if (comments.length === 0) {
      div.innerHTML = '<div class="fs4-empty">No comments yet. Be the first to share your experience!</div>';
      return div;
    }

    comments.forEach(comment => {
      div.appendChild(createCommentEl(comment, false));
      (comment.replies || []).forEach(reply => {
        div.appendChild(createCommentEl(reply, true));
      });

      // 如果正在回复这条评论，显示回复表单
      if (replyTo === comment.id && currentUser) {
        div.appendChild(createCommentForm(comment.id));
      }
    });

    return div;
  }

  function createCommentEl(comment, isReply) {
    const div = document.createElement('div');
    let cls = 'fs4-comment';
    if (isReply) cls += ' fs4-comment-reply';
    if (comment.is_solution) cls += ' fs4-solution';
    div.className = cls;

    const isAdmin = comment.role === 'admin';
    const time = new Date(comment.created_at + 'Z').toLocaleDateString('en-US', {
      month: 'short', day: 'numeric', year: 'numeric',
    });

    div.innerHTML = `
      ${comment.is_solution ? '<div class="fs4-solution-badge">✓ Solution</div>' : ''}
      <div class="fs4-comment-head">
        <span class="fs4-comment-author">${escapeHtml(comment.display_name)}</span>
        ${isAdmin ? '<span class="fs4-verified">✓ Official</span>' : ''}
        ${comment.vehicle_model ? `<span class="fs4-vehicle">🚗 ${escapeHtml(comment.vehicle_model)}</span>` : ''}
        <span class="fs4-comment-time">${time}</span>
      </div>
      <div class="fs4-comment-body">${escapeHtml(comment.content)}</div>
      <div class="fs4-comment-actions">
        <button data-action="like" data-id="${comment.id}">❤️ ${comment.likes_count || 0}</button>
        ${!isReply && currentUser ? `<button data-action="reply" data-id="${comment.id}">Reply</button>` : ''}
        ${currentUser?.role === 'admin' && !comment.is_solution && !isReply ? `<button data-action="solution" data-id="${comment.id}">Mark as solution</button>` : ''}
        ${currentUser?.role === 'admin' ? `<button data-action="delete" data-id="${comment.id}">Delete</button>` : ''}
      </div>
    `;

    setTimeout(() => {
      div.querySelectorAll('[data-action]').forEach(btn => {
        btn.addEventListener('click', () => handleAction(btn.dataset.action, parseInt(btn.dataset.id)));
      });
    }, 0);

    return div;
  }

  // ---- Actions ----
  async function handleLogin() {
    const orderInput = document.getElementById('fs4-order');
    const nameInput = document.getElementById('fs4-name');
    const errorDiv = document.getElementById('fs4-login-error');
    const btn = document.getElementById('fs4-login-btn');

    const orderNumber = orderInput?.value?.trim();
    const name = nameInput?.value?.trim();
    if (!orderNumber || !name) {
      errorDiv.innerHTML = '<div class="fs4-error">Please enter both order number and name.</div>';
      return;
    }

    btn.textContent = 'Verifying...';
    btn.disabled = true;

    try {
      const result = await api('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify({ orderNumber, name }),
      });

      if (result.success) {
        setToken(result.token);
        currentUser = result.user;
        render();
      } else {
        errorDiv.innerHTML = `<div class="fs4-error">${escapeHtml(result.error)}</div>`;
        btn.textContent = 'Verify & Sign In';
        btn.disabled = false;
      }
    } catch {
      errorDiv.innerHTML = '<div class="fs4-error">Network error. Please try again.</div>';
      btn.textContent = 'Verify & Sign In';
      btn.disabled = false;
    }
  }

  async function handleAction(action, id) {
    if (action === 'reply') {
      replyTo = id;
      render();
      // 滚动到回复框
      const form = document.getElementById(`fs4-reply-${id}-textarea`);
      form?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      form?.focus();
    } else if (action === 'like') {
      if (!currentUser) return alert('Please sign in to like.');
      await api(`/api/comments/${id}/like`, { method: 'POST' });
      await loadComments();
      render();
    } else if (action === 'solution') {
      await api(`/api/comments/${id}/solution`, { method: 'PUT' });
      await loadComments();
      render();
    } else if (action === 'delete') {
      if (!confirm('Delete this comment?')) return;
      await api(`/api/comments/${id}`, { method: 'DELETE' });
      await loadComments();
      render();
    }
  }

  async function loadComments() {
    const data = await api(`/api/comments/${articleHandle}`);
    comments = data.comments || [];
  }

  async function checkAuth() {
    const token = getToken();
    if (!token) return;
    const data = await api('/api/auth/me');
    if (data.user) {
      currentUser = data.user;
    } else {
      clearToken();
    }
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  // ---- Init ----
  async function init() {
    container.innerHTML = '<div class="fs4-loading">Loading discussion...</div>';
    await Promise.all([checkAuth(), loadComments()]);
    render();
  }

  init();
})();
